import React from 'react';
import { Maximize2, Minimize2, X } from 'lucide-react';
import '../../ChatbotStyles/ChatHeader.scss';
import boticon from '../../images/chatbot/bot-icon.svg?url';


interface ChatHeaderProps {
  onMinimize: () => void;
  onClose: () => void;
  isMinimized: boolean;
}

export const ChatHeader = ({
  onMinimize,
  onClose,
  isMinimized,
}: ChatHeaderProps) => {
  return (
    <div className="chat-header">
      <div className="header-left">
        <div className="header-icon">
          <img src={boticon} alt="bot-icon" width={33} height={30} />
        </div>
        <div className="header-text">
          <h3>Ōmcare Assistant</h3>
          <p className="tagline">Your care, powered by intelligence</p>
        </div>
      </div>

      <div className="header-actions">
        <button
          onClick={onMinimize}
          aria-label={isMinimized ? 'Maximize' : 'Minimize'}
        >
          {isMinimized ? <Maximize2 size={19} /> : <Minimize2 size={19} />}
        </button>
        <button onClick={onClose} aria-label="Close">
          <X size={27} />
        </button>
      </div>
    </div>
  );
};
